<template>
  <div class="modal-customize">
    <div
      class="customize"
      v-b-tooltip.hover
      :title="`Personalizar (${product.quantity})`"
      :id="product.id"
      v-b-modal="product.id"
      v-if="isVariationAndQuantity"
    >
      <i class="material-icons">border_color</i>
    </div>
    <b-modal ref="modalCustomize" hide-footer :id="product.id" centered :title="title">
      <form @submit.prevent="addCart()">
        <div class="row mb-3">
          <div class="col">
            <span>
              <b>Costo extra de + {{ setPrice }}</b>
            </span>
          </div>
        </div>
        <div class="row" v-for="(item, index) in customize" :key="index">
          <h6></h6>
          <div class="col-6">
            <b-form-group label="Número" label-for="number-input">
              <b-form-input
                v-model.trim="item.number"
                v-on:keypress="onlyNumber"
                required
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label="Nombre" label-for="name-input">
              <b-form-input v-model.trim="item.name" required></b-form-input>
            </b-form-group>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col right">
            <button type="button" class="btn btn-cancel" @click="resetModal()">Cancelar</button>
            <button type="submit" class="btn btn-action">Agregar</button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    customize: {
      type: Array,
      default: () => []
    },
    variations: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    name(value) {
      this.name = value.toUpperCase();
    }
  },
  data() {
    return {};
  },
  computed: {
    title() {
      return this.product ? `Personaliza ${this.product.name}` : '';
    },
    isDeliveryProccess() {
      return this.$store.getters.getIsDeliveryProccess;
    },
    setVariations() {
      return this.product ? this.product.variations.data : [];
    },
    setPrice() {
      let price = 0;
      if (this.isDeliveryProccess && !this.setVariations.length) {
        price = this.product.children[0].price * this.product.quantity;
      } else {
        price = this.product.price * this.product.quantity;
      }
      return this.product ? `${this.product.currency.symbol} ${price}` : 0;
    },
    isVariationAndQuantity(){
      return !!(Object.keys(this.variations).length !== 0 && this.product.quantity > 0);
    }
  },
  methods: {
    async addCart() {
      const cloneProduct = { ...this.product };
      const productCustomize = cloneProduct.children[0];

      delete cloneProduct.variations;
      delete cloneProduct.children;
      cloneProduct.variations = this.variations;
      cloneProduct.variationId = this.variations.id;

      const { price } = productCustomize;
      productCustomize.price = Number(price);
      productCustomize.quantity = this.customize.length;
      productCustomize.customize = this.customize;
      
      delete productCustomize.variations;
      const variationCustomize = this.product.variations.data.filter(
        (elem) => elem.id === this.variations.id
      );
      productCustomize.variations = variationCustomize[0];

      await this.$store.dispatch('updateCartProducts', cloneProduct);
      await this.$store.dispatch('updateCartProducts', productCustomize);
      this.$emit('getProducts');
      this.resetModal();
    },
    resetModal() {
      this.$refs['modalCustomize'].hide();
      this.name = '';
      this.number = '';
    },
    onlyNumber(event) {
      event = event ? event : window.event;
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        event.preventDefault();
      } else {
        return true;
      }
    }
  }
};
</script>
<style lang="scss">
.btn {
  margin-left: 5px;
}
.btn.btn-cancel {
  background-color: #e9ecef;
  border-radius: 0.25rem;
}
.customize {
  display: flex;
  width: auto;
  cursor: pointer;
  align-items: center;
  margin-top: 6px;
  justify-content: center;
  opacity: 0.8;
}
.customize:hover {
  color: #ffc107;
}
.right {
  text-align: right;
}
</style>
